export const OrderTypeEnum = Object.freeze({
  COMPLEX_ORDER_TYPE_1: 1,
  COMPLEX_ORDER_TYPE_2: 2,
  SIMPLE_ORDER_TYPE: 3,
  URGENT_SIMPLE_ORDER_TYPE: 4,
  URGENT_COMPLEX_ORDER_TYPE: 5,
});

export const OrderTypeNameEnum = Object.freeze({
  1: "Complex Order Type 1",
  2: "Complex Order Type 2",
  3: "Simple Order Type",
  4: "Urgent Simple Order Type",
  5: "Urgent Complex Order Type",
});

export const RolesEnum = Object.freeze({
  ADMIN: 1,
  LST: 2,
  HST: 3,
});

export const OrderStatusEnum = Object.freeze({
  Pending: 1,
  InProduction: 2,
  CheckedIn: 3,
  Completed: 4,
  CheckBackIn: 5,
  PickedUpAtDentist: 6,
  CheckedInLab: 7,
  InDelivery: 8,
  Transferred_To_Driver: 9
});

export const OrderStatusNames = Object.freeze({
  1: "Pending",
  2: "In Production",
  3: "Checked In",
  4: "Completed",
  5: "Check Back In",
  6: "Picked Up At Dentist",
  7: "Checked In Lab",
  8: "In Delivery",
  9: "Transferred To Driver",
});


export const OrderImageCategoryEnum = Object.freeze({
  PhotoOfTooth: "PhotoOfTooth",
  PhotoOfOriginalOrder: "PhotoOfOriginalOrder",
  PhotoOfFinishedWork: "PhotoOfFinishedWork",
});